import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { LightProgramBundleInfo } from "@modules/programBundle/entities/programBundleEntity"
import { LightProgramInfoEntity } from "@modules/programs/entities/lightProgramInfoEntity"
import { type CoachPromoCodeDto, PromoCodeStatus } from "@modules/promoCode/gateway/promoCodeDto"
import { defaultDateFormat } from "@modules/utils/dateUtils"
import dayjs from "dayjs"

export class PromoCodeEntity {
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly code: string,
    public readonly type: CouponType,
    public readonly value: number,
    public readonly createdAt: Date,
    public readonly startAt: Date | null,
    public readonly expirationDate: Date | null,
    public readonly durationInMonths: number | null,
    public readonly maxAttendees: number | null,
    public readonly onlyNewCustomer: boolean,
    public readonly programs: LightProgramInfoEntity[],
    public readonly programBundles: LightProgramBundleInfo[],
    public readonly archived: boolean,
    public readonly archivedStatus: PromoCodeStatus | null,
  ) {}

  static fromDto(dto: CoachPromoCodeDto): PromoCodeEntity {
    return new PromoCodeEntity(
      dto.id,
      dto.title,
      dto.code,
      dto.type,
      dto.value,
      new Date(dto.createdAt),
      dto.startAt ? new Date(dto.startAt) : null,
      dto.expirationDate ? new Date(dto.expirationDate) : null,
      dto.durationInMonths ?? null,
      dto.maxAttendees ?? null,
      dto.onlyNewCustomer,
      dto.programs.map((p) => LightProgramInfoEntity.fromDto(p)),
      dto.programBundles.map((pb) => LightProgramBundleInfo.fromDto(pb)),
      dto.archived,
      dto.archivedStatus,
    )
  }

  isPast(): boolean {
    return (
      this.archived ||
      (this.expirationDate ? dayjs(this.expirationDate).isBefore(dayjs().format(defaultDateFormat)) : false)
    )
  }
}
